import React from "react";

const UnsuspendMember = ({
  id,
  isUnsuspendMemberModalOpen,
  closeUnsuspendMember,
  handleUnsuspendmember,
}) => {
  const handleCancelButtonCLick = () => {
    closeUnsuspendMember();
  };

  return (
    <>
      <div
        id={id}
        className={`${
          isUnsuspendMemberModalOpen ? "flex" : "hidden"
        } flex items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="flex items-center justify-center w-full">
          <div className="relative bg-white shadow-lg rounded-sm w-[90%] max-w-[46%] mx-auto">
            <div className="mb-5 mx-auto items-center justify-center">
              <div className="flex items-center justify-between">
                <button
                  onClick={closeUnsuspendMember}
                  type="button"
                  className="bg-transparent  rounded-lg text-sm ml-auto inline-flex items-center "
                  data-modal-toggle={id}
                >
                  <svg
                    width="61"
                    height="43"
                    viewBox="0 0 61 43"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_13891_3896)">
                      <path
                        d="M32.84 28L30.7 24.9L28.9 28H25.2L28.88 22.3L25.1 16.84H28.94L31.08 19.92L32.88 16.84H36.58L32.84 22.46L36.68 28H32.84Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_13891_3896">
                        <rect width="61" height="43" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              <div className="flex flex-col mx-5">
                <p className="text-[#000000] text-[20px] font-[400]">
                Are you sure you want to unsuspend this member's account?
                </p>

                
              </div>

              <div className="flex items-center mt-12 mx-5">
                <div className="mr-5">
                  <button
                    onClick={handleCancelButtonCLick}
                    data-modal-toggle={id}
                    type="button"
                    className="text-[#074073] hover:bg-[#7FB8EB] focus:outline-none font-[500] rounded-[5px] text-md px-5 py-3 text-center 
                    bg-[#7FB8EB]"
                  >
                    No, cancel
                  </button>
                </div>
                <button
                  onClick={handleUnsuspendmember}
                  data-modal-toggle={id}
                  type="button"
                  className="text-[#FFF] bg-[#074073] hover:bg-[#074073] focus:outline-none font-[500] rounded-[5px] text-[16px] text-medium px-12 py-3 text-center"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UnsuspendMember;
